import React from 'react';

const MentionsLegal = () => {
    return (
        <div>
            <h1>Mentions légales</h1>
        </div>
    );
}

export default MentionsLegal;